document.getElementById('cart-icon-bubble')
  .addEventListener(
    'click',
    function (e) {
      $('#cart-drawer').addClass('open');
      $('.custom_overlay2').addClass('active');
    },
    true // 👈 capture phase (CRITICAL)
  );

document.addEventListener('rebuy:cart.add', (event) => { 

      $.get(window.location.pathname, function (res) {
        var $new = $(res).find('#cart_drawer_content');
        $('#cart_drawer_content').replaceWith($new);
        $('#cart-drawer').removeClass('is_empty').addClass('open');
        $('.custom_overlay2').addClass('active');
      });
});